import { TextArea } from "@/components";
import { Box } from "@chakra-ui/react";
import { CustomText, Wrapper } from "./termModalContent.style";

export const TermModalContent = ({ title, contents }: { title: string; contents: string }) => {
    return (
        <Wrapper>
            <CustomText>{title}</CustomText>
            <Box flex={"1"}>
                <TextArea content={contents}></TextArea>
            </Box>
        </Wrapper>
    );
};
